import { render } from "./ReportMaterialUsage.vue?vue&type=template&id=ff5a4592&scoped=true"
import script from "./ReportMaterialUsage.vue?vue&type=script&lang=js"
export * from "./ReportMaterialUsage.vue?vue&type=script&lang=js"

import "./ReportMaterialUsage.vue?vue&type=style&index=0&id=ff5a4592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff5a4592"]])

export default __exports__